import React from 'react';
import { connect } from 'react-redux';
import { AccumulatorsBlock as _AccumulatorsBlock } from '@beef/elk-common';
import { TariffSettingButton } from "../TariffSettingButton";
import { AccumulatorList } from "../AccumulatorList";
import { selectAccumsPending, selectAccumulatorsError, selectClosestExpiringAdditionalAccumulatorInfo, selectIsManageAccumLink } from "../Mobile/store";
import { ConnectionBlockActionCreator } from "../store/actions";
import { InfoTag } from "../Mobile/InfoTag";
var mapStateToProps = function mapStateToProps(state) {
  return {
    tariffUrl: selectIsManageAccumLink(state),
    isPending: selectAccumsPending(state),
    hasError: selectAccumulatorsError(state),
    additionalBillingInfo: selectClosestExpiringAdditionalAccumulatorInfo(state),
    tariffSettingButtonSlot: /*#__PURE__*/React.createElement(TariffSettingButton, {
      tariffUrl: selectIsManageAccumLink(state),
      "data-t-id": "ConnectionBlock-AccumulatorsBlock"
    }),
    accumulatorListSlot: /*#__PURE__*/React.createElement(AccumulatorList, null),
    infoTagSlot: /*#__PURE__*/React.createElement(InfoTag, null)
  };
};
var mapDispatchToProps = {
  onRefreshButtonClick: ConnectionBlockActionCreator.fetchAccumulators
};
export var AccumulatorsBlock = connect(mapStateToProps, mapDispatchToProps)(_AccumulatorsBlock);